<dashboard-loader *ngIf="isLoadingTemplateConfig | async" [title]="'Loading template config...'"></dashboard-loader>
<div
  *ngIf="templateConfigLoaded | async"
  class="dashboard-profile-configuration"
  fxFill
  fxLayout="column"
  fxLayoutAlign="space-between"
  fxLayoutGap="30px"
>
  <h1 class="dashboard-profile-configuration-title">Mean Factors input form</h1>
  <form [formGroup]="factorsForm" dashboardConnectForm [connectForm]="selectedFactor ? selectedFactor : null">
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="10px">
      <mat-form-field appearance="fill" fxFlex="33">
        <mat-label>Select Calculated Variable</mat-label>
        <mat-select [formControl]="calculatedVariableId">
          <mat-option *ngFor="let calculatedVariable of calculatedVariables" [value]="calculatedVariable.id">
            {{ calculatedVariable.uniqueName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="calculatedVariableId.hasError('required') && calculatedVariableId.touched">
          Calculated variable is <strong>required</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" fxFlex="33">
        <mat-label>Label</mat-label>
        <input matInput formControlName="name" />
        <mat-error *ngIf="name.hasError('required') && name.touched">
          Factor label is <strong>required</strong>
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" fxFlex="33">
        <mat-label>Value</mat-label>
        <input type="number" matInput formControlName="value" />
        <mat-error *ngIf="value.hasError('required') && value.touched">
          Factor value is <strong>required</strong>
        </mat-error>
      </mat-form-field>
    </div>
  </form>
  <div fxLayout="row" fxLayout="end" fxLayoutGap="20px">
    <button mat-raised-button color="accent" (click)="saveEditingFactor()" *ngIf="isEditingFactor">
      {{ 'Save' | uppercase }}
    </button>
    <button mat-button color="warn" (click)="deleteFactor()" *ngIf="isEditingFactor">
      {{ 'Delete' | uppercase }}
    </button>
    <button mat-button (click)="cancelEditingFactor()" *ngIf="isEditingFactor">
      {{ 'Cancel' | uppercase }}
    </button>
    <button mat-raised-button color="accent" (click)="addFactor()" *ngIf="!isEditingFactor">
      {{ 'Add factor' | uppercase }}
    </button>
  </div>
  <div fxLayout="row">
    <table
      mat-table
      [dataSource]="dataSource"
      [hidden]="!dataSource?.data.length"
      class="dashboard-profile-configuration__table"
      fxFill
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Label</th>
        <td mat-cell *matCellDef="let factor">
          {{ factor?.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>Value</th>
        <td mat-cell *matCellDef="let factor">
          {{ factor?.value }}
        </td>
      </ng-container>
      <tr class="dashboard-profile-configuration__table-header" mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr
        mat-row
        *matRowDef="let row; let i = index; columns: columnsToDisplay"
        class="dashboard-profile-configuration__table-row"
        (click)="editFactor(row, i)"
      ></tr>
    </table>
  </div>
  <div fxLayout="row" fxLayout="end">
    <button
      mat-raised-button
      color="accent"
      (click)="saveConfiguration()"
      [disabled]="isEditingFactor || !factors?.length"
    >
      {{ 'Save configuration' | uppercase }}
    </button>
  </div>
</div>
